import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prg-add-programming',
  templateUrl: './add-programming.component.html',
  styleUrls: ['./add-programming.component.css']
})
export class AddProgrammingComponent implements OnInit {

  constructor( ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/add-programming/add-programming.component.ts